import { Activity } from '@cms-max/medicare-api-sdk'
import generator, { EventMapKeys } from './baseGenerator'

export const accountSettingsGenerator = generator(({ i18n }) => {
  const ns = 'accountSettings'
  return ({
    // Update Email Modal: Close
    accountsettings_emailclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Account Settings',
        elementId: 'accountsettings_emailclose_click'
      }
    },
    // Update eMSN Settings Modal: Close
    accountsettings_emsnclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Account Settings',
        elementId: 'accountsettings_emsnclose_click'
      }
    },
    // Update Handbook Settings Modal: Close
    accountsettings_handbookclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Account Settings',
        elementId: 'accountsettings_handbookclose_click'
      }
    },
    // Order Medicare Card Modal: Close
    accountsettings_ordercardclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Account Settings',
        elementId: 'accountsettings_ordercardclose_click'
      }
    },
    // Update Password Modal: Close
    accountsettings_password_close: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Account Settings',
        elementId: 'accountsettings_password_close'
      }
    },
    // Update Secret Question Modal: Close
    accountsettings_secretclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Account Settings',
        elementId: 'accountsettings_secretclose_click'
      }
    },
    // Update Name/Address (SS) Drawer: Open
    accountsettings_ssupdatenameoraddress_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: 'Account Settings',
        elementId: 'accountsettings_ssupdatenameoraddress_opendrawer'
      }
    },
    // Update Name/Address (RRB) Drawer: Open
    accountsettings_rrbupdatenameoraddress_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: 'Account Settings',
        elementId: 'accountsettings_rrbupdatenameoraddress_opendrawer'
      }
    },
    // Update Name/Address (RRB) Drawer: Close
    accountsettings_rrbpdatenameoraddress_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: 'Account Settings',
        elementId: 'accountsettings_rrbpdatenameoraddress_closedrawer'
      }
    },
    // Update Name/Address (SS) Drawer: Close
    accountsettings_ssupdatenameoraddress_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: 'Account Settings',
        elementId: 'accountsettings_ssupdatenameoraddress_closedrawer'
      }
    },
    // Update Name/Address (RRB) Drawer: Link 1 Click
    accountsettings_drawerrrbupdatenameoraddress_click: {
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: 'Account Settings',
        elementId: 'accountsettings_drawerrrbupdatenameoraddress_click',
        coreClickData: {
          linkText: i18n.t('drawer.rrb.li1.linkText', { ns }),
          linkUrl: 'https://rrb.gov/Benefits/myRRB'
        }
      }
    },
    // Update Name/Address (RRB) Drawer: Link 3 Click
    accountsettings_drawerrrbofficefinder_click: {
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: 'Account Settings',
        elementId: 'accountsettings_drawerrrbofficefinder_click',
        coreClickData: {
          linkText: i18n.t('drawer.rrb.li3.linkText', { ns }),
          linkUrl: 'https://rrb.gov/Field-Office-Locator'
        }
      }
    },
    // Update Name/Address (SS) Drawer: Link 1 Click
    accountsettings_drawerssupdatenameoraddress_click: {
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: 'Account Settings',
        elementId: 'accountsettings_drawerssupdatenameoraddress_click',
        coreClickData: {
          linkText: i18n.t('drawer.ssa.li1.linkText', { ns }),
          linkUrl: 'https://www.ssa.gov/myaccount/'
        }
      }
    },
    // Update Name/Address (SS) Drawer: Link 3 Click
    accountsettings_drawerssofficefinder_click: {
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: 'Account Settings',
        elementId: 'accountsettings_drawerssofficefinder_click',
        coreClickData: {
          linkText: i18n.t('drawer.ssa.li3.linkText', { ns }),
          linkUrl: 'https://www.ssa.gov/myaccount/'
        }
      }
    },
    // Update Username Modal: Close
    accountsettings_username_close: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Account Settings',
        elementId: 'accountsettings_username_close'
      }
    }
  })
})

export type AccountSettingsKeys = EventMapKeys<typeof accountSettingsGenerator>

export default accountSettingsGenerator
